export const NewCleaningCompany = "+ Add New Company"
export const CompanyName = "Company Name"
export const CompanyEmail = "Company Email"
export const Coverage = "Coverage"
export const Action = "Action"
export const AcrossCoop = "Across Co-op"
export const AddNewCompany = "Add New Company"
export const EditCompany = "Edit Company"
export const Mandatory = "indicates mandatory field"
export const Cancel = "Cancel"
export const CompanyNull = "Please enter the company name"
export const EmailNull = "Please enter the email"
export const EmailValid = "Please enter the valid email"
export const CompanyAlreadyExists = "Cleaner company already exists."
export const NoPermisssion = "Please create a company that you are mapped"
export const NoDataAvailable = "No data available"
export const Alert = "Alert"
export const Delete = "Do you want to delete?"
